<!-- <div class="image-container">
    <img style="padding: 0; margin: 0;" src="assets/navimage.png" width="100%" alt="Your Image">
    <div class="image-text">
      <p>Dresses</p>
    </div>
</div> -->
<div class="container-fluid">
    <div class="hero">
        PARENTS ARE WELCOME TO BUY THE DRESSES FROM ANY SHOP OF THERE PREFERENCE
    </div>
    <div class="gallery">
        <div class="gallery-item">
            <img src="../../../assets/Dresses/skirt.PNG" alt="Image 1">
        </div>
        <div class="gallery-item">
            <img src="../../../assets/Dresses/Tie.PNG" alt="Image 2">
        </div>
        <div class="gallery-item">
            <img src="../../../assets/Dresses/shirt.PNG" alt="Image 2">
        </div>
    </div>
    <div class="gallery">
        <div class="gallery-item">
            <img src="../../../assets/Dresses/belt.PNG" alt="Image 1">
        </div>
        <div class="gallery-item">
            <img src="../../../assets/Dresses/pant.PNG" alt="Image 2">
        </div>
        <div class="gallery-item">
            <img src="../../../assets/Dresses/socks.PNG" alt="Image 2">
        </div>
    </div>
</div>